/**
 * videojs-range-slider
 * @version 0.0.0
 * @copyright 2019 amina abdelkafi
 * @license MIT
 */
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.videojsRangeSlider = factory());
}(this, (function () { 'use strict';

var version = "0.0.0";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component = videojs.getComponent('Component');
/**
 * send mail button.
 */

var ControlTimePanel = function (_Component) {
    inherits(ControlTimePanel, _Component);

    function ControlTimePanel(player, options) {
        classCallCheck(this, ControlTimePanel);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;

        options = options || {}; // plugin options

        _this.options = options;
        return _this;
    }

    /*Constructor*/


    ControlTimePanel.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
    };

    ControlTimePanel.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-controltimepanel-RS vjs-control'
        });
    };

    ControlTimePanel.prototype.enable = function enable(enable) {
        var enable = typeof enable != 'undefined' ? enable : true;
        this.rs.ctpl.el_.children[0].disabled = enable ? "" : "disabled";
        this.rs.ctpl.el_.children[1].disabled = enable ? "" : "disabled";
        this.rs.ctpl.el_.children[2].disabled = enable ? "" : "disabled";
        this.rs.ctpr.el_.children[0].disabled = enable ? "" : "disabled";
        this.rs.ctpr.el_.children[1].disabled = enable ? "" : "disabled";
        this.rs.ctpr.el_.children[2].disabled = enable ? "" : "disabled";
    };

    return ControlTimePanel;
}(Component);

ControlTimePanel.prototype.options_ = {
    children: {
        'ControlTimePanelLeft': {},
        'ControlTimePanelRight': {}
    }
};

var Component$1 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var RSTimeBar = function (_Component) {
    inherits(RSTimeBar, _Component);

    function RSTimeBar(player, options) {
        classCallCheck(this, RSTimeBar);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;

        options = options || {}; // plugin options

        _this.options = options;

        return _this;
    }

    /*Constructor*/


    RSTimeBar.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
    };

    RSTimeBar.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            innerHTML: '',
            className: 'vjs-timebar-RS'
        });
    };

    return RSTimeBar;
}(Component$1);

RSTimeBar.prototype.options_ = {
    children: {
        'SeekRSBar': {}
    }
};

var Component$2 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var RSTimeBar$2 = function (_Component) {
    inherits(RSTimeBar, _Component);

    function RSTimeBar(player, options) {
        classCallCheck(this, RSTimeBar);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;

        _this.on('keyup', _this.onKeyUp);
        _this.on('keydown', _this.onKeyDown);

        options = options || {}; // plugin options

        _this.options = options;
        return _this;
    }

    /*Constructor*/


    RSTimeBar.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
        this.timeOld = {};
    };

    RSTimeBar.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-controltimepanel-left-RS',
            innerHTML: 'Démarrage de lecture: <input type="text" id="controltimepanell1" maxlength="2" value="00"/>:<input type="text" id="controltimepanell2" maxlength="2" value="00"/>:<input type="text" id="controltimepanell3" maxlength="2" value="00"/>'
        });
    };

    RSTimeBar.prototype.onKeyDown = function onKeyDown(event) {
        this.timeOld[0] = this.el_.children[0].value;
        this.timeOld[1] = this.el_.children[1].value;
        this.timeOld[2] = this.el_.children[2].value;
    };

    RSTimeBar.prototype.onKeyUp = function onKeyUp(event) {
        if (event.keyCode == 38) this.updateValueCtrTimeLeft(event.target.id, 1);else if (event.keyCode == 40) this.updateValueCtrTimeLeft(event.target.id, -1);
        this.rs._checkControlTime(0, this.el_.children, this.timeOld);
    };

    RSTimeBar.prototype.updateValueCtrTimeLeft = function updateValueCtrTimeLeft(id, number) {
        document.getElementById(id).value = parseInt(document.getElementById(id).value) + number;
    };

    return RSTimeBar;
}(Component$2);

var Component$3 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var ControlTimePanelRight = function (_Component) {
    inherits(ControlTimePanelRight, _Component);

    function ControlTimePanelRight(player, options) {
        classCallCheck(this, ControlTimePanelRight);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;

        _this.on('keyup', _this.onKeyUp);
        _this.on('keydown', _this.onKeyDown);
        options = options || {}; // plugin options

        _this.options = options;
        return _this;
    }

    /*Constructor*/


    ControlTimePanelRight.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
        this.timeOld = {};
    };

    ControlTimePanelRight.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-controltimepanel-right-RS',
            innerHTML: 'Fin de lecture: <input type="text" id="controltimepanelr1" maxlength="2" value="00"/>:<input type="text" id="controltimepanelr2" maxlength="2" value="00"/>:<input type="text" id="controltimepanelr3" maxlength="2" value="00"/>'

        });
    };

    ControlTimePanelRight.prototype.onKeyDown = function onKeyDown(event) {
        this.timeOld[0] = this.el_.children[0].value;
        this.timeOld[1] = this.el_.children[1].value;
        this.timeOld[2] = this.el_.children[2].value;
    };

    ControlTimePanelRight.prototype.onKeyUp = function onKeyUp(event) {
        if (event.keyCode == 38) this.updateValueCtrTimeRight(event.target.id, 1);else if (event.keyCode == 40) this.updateValueCtrTimeRight(event.target.id, -1);
        this.rs._checkControlTime(1, this.el_.children, this.timeOld);
    };

    ControlTimePanelRight.prototype.updateValueCtrTimeRight = function updateValueCtrTimeRight(id, number) {
        document.getElementById(id).value = parseInt(document.getElementById(id).value) + number;
    };

    return ControlTimePanelRight;
}(Component$3);

var Component$4 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var SeekRSBar = function (_Component) {
  inherits(SeekRSBar, _Component);

  function SeekRSBar(player, options) {
    classCallCheck(this, SeekRSBar);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-range-control-bar');
    _this.player = player;
    options = options || {}; // plugin options

    _this.options = options;

    _this.on('mousedown', _this.onMouseDown);
    _this.on('touchstart', _this.onMouseDown);

    return _this;
  }

  /*Constructor*/


  SeekRSBar.prototype.init_ = function init_() {
    this.rs = this.player_.rangeslider;
  };

  SeekRSBar.prototype.createEl = function createEl() {
    return _Component.prototype.createEl.call(this, 'div', {
      className: 'vjs-rangeslider-holder'
    });
  };

  SeekRSBar.prototype.onMouseDown = function onMouseDown(event) {
    event.preventDefault();
    videojs.dom.blockTextSelection();

    if (!this.rs.options.locked) {
      videojs.on(document, "mousemove", videojs.bind(this, this.onMouseMove));
      videojs.on(document, "mouseup", videojs.bind(this, this.onMouseUp));
      videojs.on(document, "touchmove", videojs.bind(this, this.onMouseMove));
      videojs.on(document, "touchend", videojs.bind(this, this.onMouseUp));
    }
  };

  SeekRSBar.prototype.onMouseUp = function onMouseUp(event) {
    var left = this.calculateDistance(event);

    var ObjLeft = this.rs.left.el_.style.left.replace("%", ""),
        ObjRight = this.rs.right.el_.style.left.replace("%", "");
    if (left * 100 - ObjLeft * 1 < ObjRight * 1 - left * 100) this.setPosition(0, left);else this.setPosition(1, left);

    videojs.off(document, "mousemove", this.onMouseMove, false);
    videojs.off(document, "mouseup", this.onMouseUp, false);
    videojs.off(document, "touchmove", this.onMouseMove, false);
    videojs.off(document, "touchend", this.onMouseUp, false);
  };

  SeekRSBar.prototype.onMouseMove = function onMouseMove(event) {
    var left = this.calculateDistance(event);

    if (this.rs.left.pressed) this.setPosition(0, left);else if (this.rs.right.pressed) this.setPosition(1, left);

    this.player_.currentTime(this.rs._seconds(left));

    // Trigger slider change
    if (this.rs.left.pressed || this.rs.right.pressed) {
      this.rs._triggerSliderChange();
    }
  };

  SeekRSBar.prototype.setPosition = function setPosition(index, left, writeControlTime) {
    var writeControlTime = typeof writeControlTime != 'undefined' ? writeControlTime : true;
    //index = 0 for left side, index = 1 for right side
    var index = index || 0;

    if (this.rs !== undefined) {

      // Position shouldn't change when handle is locked
      if (this.rs.options.locked) return false;

      // Check for invalid position
      if (isNaN(left)) return false;

      // Check index between 0 and 1
      if (!(index === 0 || index === 1)) return false;
      // Alias
      var ObjLeft = this.rs.left.el_,
          ObjRight = this.rs.right.el_,
          Obj = this.rs[index === 0 ? 'left' : 'right'].el_,
          tpr = this.rs.tpr.el_,
          tpl = this.rs.tpl.el_,
          bar = this.rs.bar,
          ctp = this.rs[index === 0 ? 'ctpl' : 'ctpr'].el_;

      //Check if left arrow is passing the right arrow
      if (index === 0 ? bar.updateLeft(left) : bar.updateRight(left)) {
        Obj.style.left = left * 100 + '%';
        index === 0 ? bar.updateLeft(left) : bar.updateRight(left);

        this.rs[index === 0 ? 'start' : 'end'] = this.rs._seconds(left);

        //Fix the problem  when you press the button and the two arrow are underhand
        //left.zIndex = 10 and right.zIndex=20. This is always less in this case:
        if (index === 0) {
          if (left >= 0.9) ObjLeft.style.zIndex = 25;else ObjLeft.style.zIndex = 10;
        }

        //-- Panel
        var TimeText = videojs.formatTime(this.rs._seconds(left)),
            tplTextLegth = tpl.children[0].innerHTML.length;
        var MaxP, MinP, MaxDisP;
        if (tplTextLegth <= 4) //0:00
          MaxDisP = this.player_.isFullScreen ? 3.25 : 6.5;else if (tplTextLegth <= 5) //00:00
          MaxDisP = this.player_.isFullScreen ? 4 : 8;else //0:00:00
          MaxDisP = this.player_.isFullScreen ? 5 : 10;
        if (TimeText.length <= 4) {
          //0:00
          MaxP = this.player_.isFullScreen ? 97 : 100;
          MinP = this.player_.isFullScreen ? 0.1 : 0;
        } else if (TimeText.length <= 5) {
          //00:00
          MaxP = this.player_.isFullScreen ? 96 : 92;
          MinP = this.player_.isFullScreen ? 0.1 : 0.5;
        } else {
          //0:00:00
          MaxP = this.player_.isFullScreen ? 95 : 91;
          MinP = this.player_.isFullScreen ? 0.1 : 0.5;
        }

        if (index === 0) {
          tpl.style.left = Math.max(MinP, Math.min(MaxP, left * 100 - MaxDisP / 2)) + '%';

          if (tpr.style.left.replace("%", "") - tpl.style.left.replace("%", "") <= MaxDisP) tpl.style.left = Math.max(MinP, Math.min(MaxP, tpr.style.left.replace("%", "") - MaxDisP)) + '%';
          TimeText = videojs.formatTime(this.rs._getArrowValue(index));
          tpl.children[0].innerHTML = TimeText;
        } else {
          tpr.style.left = Math.max(MinP, Math.min(MaxP, left * 100 - MaxDisP / 2)) + '%';

          if ((tpr.style.left.replace("%", "") || 100) - tpl.style.left.replace("%", "") <= MaxDisP) tpr.style.left = Math.max(MinP, Math.min(MaxP, tpl.style.left.replace("%", "") - 0 + MaxDisP)) + '%';
          TimeText = videojs.formatTime(this.rs._getArrowValue(index));
          tpr.children[0].innerHTML = TimeText;
        }
        tpl.style.left = this.rs.bar.el_.style.left.replace("%", "") + "%";
        tpr.style.left = this.rs.bar.el_.style.left.replace("%", "") * 1 + this.rs.bar.el_.style.width.replace("%", "") * 1 + "%";
        //-- Control Time
        if (writeControlTime) {
          var time = TimeText.split(":"),
              h,
              m,
              s;
          if (time.length == 2) {
            h = 0;
            m = time[0];
            s = time[1];
          } else {
            h = time[0];
            m = time[1];
            s = time[2];
          }
          ctp.children[0].value = h;
          ctp.children[1].value = m;
          ctp.children[2].value = s;
        }
      }
    }
    return true;
  };

  SeekRSBar.prototype.calculateDistance = function calculateDistance(event) {
    var rstbX = this.getRSTBX();
    var rstbW = this.getRSTBWidth();
    var handleW = this.getWidth();

    // Adjusted X and Width, so handle doesn't go outside the bar
    rstbX = rstbX + handleW / 2;
    rstbW = rstbW - handleW;

    // Percent that the click is through the adjusted area
    //during touch event.pageX is not present
    if (event.pageX) {
      return Math.max(0, Math.min(1, (event.pageX - rstbX) / rstbW));
    } else {
      //this is a touch event
      return Math.max(0, Math.min(1, (event.touches[0].pageX - rstbX) / rstbW));
    }
  };

  SeekRSBar.prototype.getRSTBWidth = function getRSTBWidth() {
    return this.el_.offsetWidth;
  };

  SeekRSBar.prototype.getRSTBX = function getRSTBX() {
    return videojs.dom.findPosition(this.el_).left;
  };

  SeekRSBar.prototype.getWidth = function getWidth() {
    return this.rs.left.el_.offsetWidth; //does not matter left or right
  };

  return SeekRSBar;
}(Component$4);

SeekRSBar.prototype.options_ = {
  children: {
    'SelectionBar': {},
    'SelectionBarLeft': {},
    'SelectionBarRight': {},
    'TimePanel': {}
  }
};

var Component$5 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var SelectionBar = function (_Component) {
    inherits(SelectionBar, _Component);

    function SelectionBar(player, options) {
        classCallCheck(this, SelectionBar);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;

        options = options || {}; // plugin options

        _this.options = options;

        _this.on('mouseup', _this.onMouseUp);
        _this.on('touchend', _this.onMouseUp);
        _this.fired = false;

        return _this;
    }

    /*Constructor*/


    SelectionBar.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
        this.player.on('updateSliderLeft', this.updateSliderLeft);
        this.player.on('updateSliderRight', this.updateSliderRight);
        this.player.on('timeupdate', this.updateSliderRightLeftTime);
    };

    SelectionBar.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-selectionbar-RS'
        });
    };

    SelectionBar.prototype.updateSliderLeft = function updateSliderLeft() {
        this.rs = this.player_.rangeslider;

        var startDuration = this.player_.currentTime();
        this.rs.startDuration = startDuration;
        var duration = this.player_.duration();
        var start = startDuration / duration;
        this.rs.bar.updateLeft(start);
        console.log("updateSliderLeft", start);
    };

    SelectionBar.prototype.updateSliderRightLeftTime = function updateSliderRightLeftTime() {

        if (this.rs && this.rs.endDuration) {

            if (this.player_.currentTime() >= this.rs.endDuration) {
                document.getElementById('start-button-rs').disabled = true;
            } else {
                document.getElementById('start-button-rs').disabled = false;
            }
        }
        if (this.rs && this.rs.startDuration) {
            if (this.player_.currentTime() <= this.rs.startDuration) {
                document.getElementById('end-button-rs').disabled = true;
            } else {
                document.getElementById('end-button-rs').disabled = false;
            }
        }
    };

    SelectionBar.prototype.updateSliderRight = function updateSliderRight() {
        this.rs = this.player_.rangeslider;
        var endDuration = this.player_.currentTime();
        this.rs.endDuration = endDuration;
        var duration = this.player_.duration();
        var end = endDuration / duration;
        this.rs.bar.updateRight(end);
        console.log("updateSliderRight", end);
    };

    SelectionBar.prototype.onMouseUp = function onMouseUp() {
        var start = this.rs.left.el_.style.left.replace("%", ""),
            end = this.rs.right.el_.style.left.replace("%", ""),
            duration = this.player_.duration(),
            precision = this.rs.updatePrecision,
            segStart = Math.round(start * duration / 100, precision),
            segEnd = Math.round(end * duration / 100, precision);
        this.player_.currentTime(segStart);
        this.player_.play();
        this.rs.bar.activatePlay(segStart, segEnd);
    };

    SelectionBar.prototype.updateLeft = function updateLeft(left) {

        var rightVal = this.rs.right.el_.style.left != '' ? this.rs.right.el_.style.left : 100;
        var right = parseFloat(rightVal);
        var width = Math.round(right - left * 100, this.rs.updatePrecision); //round necessary for not get 0.6e-7 for example that it's not able for the html css width
        right = right / 100;
        //(right+0.00001) is to fix the precision of the css in html
        if (left <= right + 0.001) {
            this.rs['left'].el_.style.left = left * 100 + '%';
            this.rs.bar.el_.style.left = left * 100 + '%';
            this.rs.bar.el_.style.width = width + '%';
            return true;
        }
        return false;
    };

    SelectionBar.prototype.updateRight = function updateRight(right) {
        var leftVal = this.rs.left.el_.style.left != '' ? this.rs.left.el_.style.left : 0;
        var left = parseFloat(leftVal);

        var width = Math.round(right * 100 - left, this.rs.updatePrecision); //round necessary for not get 0.6e-7 for example that it's not able for the html css width
        left = left / 100;
        //(right+0.00001) is to fix the precision of the css in html
        if (right + 0.00001 >= left) {
            this.rs['right'].el_.style.left = right * 100 + '%';
            this.rs.bar.el_.style.width = width + '%';
            this.rs.bar.el_.style.left = right * 100 - width + '%';
            return true;
        }
        return false;
    };

    SelectionBar.prototype.activatePlay = function activatePlay(start, end) {
        this.timeStart = start;
        this.timeEnd = end;

        this.suspendPlay();

        this.player_.on("timeupdate", videojs.bind(this, this._processPlay));
    };

    SelectionBar.prototype.updateCurrentTimeImage = function updateCurrentTimeImage(currentDuration) {

        this.player_.trigger("timeupdateImage", currentDuration);
    };

    SelectionBar.prototype.activateSequence = function activateSequence(sequence, num_seq) {
        var self = this;

        if (!!!this.rs.paramClosePlaySequence && sequence.length > num_seq && sequence[num_seq].start !== sequence[num_seq].end) {
            window.currentMediaSequence = num_seq;
            this.timeStart = sequence[num_seq].start;
            this.timeEnd = sequence[num_seq].end;
            this.num_seq = num_seq;
            this.sequence = sequence;
            var videoElement = self.player.el().querySelector('video');
            if (!sequence[num_seq].isImageFull) {
                // change the source of video to play list of videos
                var typeS = sequence[num_seq].sources ? sequence[num_seq].sources[0].type : "video/mp4";
                var srcS = sequence[num_seq].sources ? sequence[num_seq].sources[0].src : sequence[num_seq].src;
                if (srcS !== undefined && srcS !== this.player_.currentSrc()) {
                    this.player_.src({ type: typeS, src: srcS });
                }
                if (videoElement) {
                    videoElement.classList = "vjs-tech selectedVideo";
                    var cl = videoElement.className;
                    if (typeof cl === 'string') {
                        videoElement.className = (self.getTransitionSequence(sequence[num_seq]) + ' ' + cl).trim();
                    }
                }

                this.rs.unlock();
                if (num_seq >= 1) {
                    if (this.timeStart > sequence[num_seq - 1].end) {
                        this.rs.box.setPosition(1, this.rs._percent(sequence[num_seq].end));
                        this.rs.box.setPosition(0, this.rs._percent(sequence[num_seq].start));
                    } else {
                        this.rs.box.setPosition(0, this.rs._percent(sequence[num_seq].start));
                        this.rs.box.setPosition(1, this.rs._percent(sequence[num_seq].end));
                    }
                } else {
                    this.rs.box.setPosition(0, this.rs._percent(sequence[num_seq].start));
                    this.rs.box.setPosition(1, this.rs._percent(sequence[num_seq].end));
                }
                this.rs.lock();
                //this.rs.unlock();
                this.suspendPlaySequence();
                this.player_.play();
                this.player_.currentTime(this.timeStart);
                this.player_.on("timeupdate", videojs.bind(this, this._processPlaySequence));
            } else {
                self._playImage(sequence[num_seq]);
                this.player_.src({});
                if (videoElement) {
                    videoElement.classList = "vjs-tech selectedVideo";
                    var _cl = videoElement.className;
                    if (typeof _cl === 'string') {
                        videoElement.className = (self.getTransitionSequence(sequence[num_seq]) + ' ' + _cl).trim();
                    }
                }
                var durationImage = sequence[num_seq].end - sequence[num_seq].start;
                var currentDuration = 0;
                var updateCurrentTimeImage = setInterval(function () {
                    if (currentDuration == 0) {
                        self.player_.pause();
                    }
                    currentDuration += 1;
                    self.updateCurrentTimeImage(currentDuration);

                    if (durationImage == currentDuration) {
                        clearInterval(updateCurrentTimeImage);
                        self.activateSequence(self.sequence, self.num_seq + 1);
                        if (!self.fired) {
                            //Do nothing if end has already been called
                            return;
                        }
                        self.fired = false; //Set fired flat to false
                    }
                }, 1000);
            }
        } else {
            if (!this.fired) {
                //Do nothing if end has already been called
                return;
            }
            this.fired = false; //Set fired flat to false
            this.player_.pause(); //Call end function
            this.suspendPlaySequence();
        }
    };

    SelectionBar.prototype._playImage = function _playImage(sequence) {
        var self = this;
        var imageElement = self.player.el().querySelector('image_Full-Screen_Montage');
        if (imageElement) {
            imageElement.style.backgroundImage = "url(" + sequence.content + ")";
            imageElement.classList.add(self.getTransitionSequence(sequence));
        } else {
            imageElement = document.createElement("div");
            imageElement.id = "image_Full-Screen_Montage";
            imageElement.style.backgroundImage = "url(" + sequence.content + ")";
            imageElement.className = "imageFullScreenMontage " + self.getTransitionSequence(sequence);
            self.player.el().appendChild(imageElement);
        }
    };

    SelectionBar.prototype.getTransitionSequence = function getTransitionSequence(sequence) {
        var transition = "";
        if (sequence !== undefined && sequence.transition) {
            var type = sequence.transition.typeTransition;
            if (type === "bottom") {
                transition = "animation-enter-bottom";
            } else if (type === "right") {
                transition = "animation-enter-right";
            } else if (type === "left") {
                transition = "animation-left";
            } else if (type === "top") {
                transition = "animation-top";
            } else if (type === "no-transition") {
                transition = "no-transition";
            } else {
                transition = "";
            }
        }
        return transition;
    };

    SelectionBar.prototype.suspendPlay = function suspendPlay() {
        this.fired = false;
        this.player_.off("timeupdate", videojs.bind(this, this._processPlay));
    };

    SelectionBar.prototype.suspendPlaySequence = function suspendPlaySequence() {
        this.fired = false;
        this.player_.off("timeupdate", videojs.bind(this, this._processPlaySequence));
    };

    SelectionBar.prototype.closePlaySequence = function closePlaySequence() {
        this.rs.paramClosePlaySequence = true;
        this.rs.unlock();
        this.player_.off("timeupdate", videojs.bind(this, this._processPlaySequence));
    };

    SelectionBar.prototype._processPlaySequence = function _processPlaySequence() {
        //Check if current time is between start and end
        if (this.player.currentTime() >= this.timeStart && (this.timeEnd < 0 || this.player.currentTime() < this.timeEnd)) {
            this.fired = true;
        } else {
            if (this.player.currentTime() < this.timeStart) {
                this.player.currentTime(this.timeStart);
                return;
            }
            //Set fired flat to false
            if (!this.fired) {
                //Do nothing if end has already been called
                return;
            }
            if (!this.sequence[window.currentMediaSequence].isImageFull) this.activateSequence(this.sequence, this.num_seq + 1);
        }
    };

    SelectionBar.prototype._processPlay = function _processPlay() {
        //Check if current time is between start and end
        if (this.player_.currentTime() >= this.timeStart && (this.timeEnd < 0 || this.player_.currentTime() < this.timeEnd)) {
            if (this.fired) {
                //Do nothing if start has already been called
                return;
            }
            this.fired = true; //Set fired flag to true
        } else {
            if (!this.fired) {
                //Do nothing if end has already been called
                return;
            }
            this.fired = false; //Set fired flat to false
            this.player_.pause(); //Call end function
            this.player_.currentTime(this.timeEnd);
            this.suspendPlay();
        }
    };

    SelectionBar.prototype.process_loop = function process_loop() {
        var player = this.player;

        if (player && this.looping) {
            var current_time = player.currentTime();

            if (current_time < this.timeStart || this.timeEnd > 0 && this.timeEnd < current_time) {
                player.currentTime(this.timeStart);
            }
        }
    };

    return SelectionBar;
}(Component$5);

var Component$6 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var SelectionBarLeft = function (_Component) {
    inherits(SelectionBarLeft, _Component);

    function SelectionBarLeft(player, options) {
        classCallCheck(this, SelectionBarLeft);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;

        _this.on('mousedown', _this.onMouseDown);
        _this.on('touchstart', _this.onMouseDown);
        _this.pressed = false;
        options = options || {}; // plugin options

        _this.options = options;

        return _this;
    }

    /*Constructor*/


    SelectionBarLeft.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
    };

    SelectionBarLeft.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-rangeslider-handle vjs-selectionbar-left-RS',
            innerHTML: '<div class="vjs-selectionbar-arrow-RS"></div><div class="vjs-selectionbar-line-RS"></div>'

        });
    };

    SelectionBarLeft.prototype.onMouseDown = function onMouseDown(event) {
        event.preventDefault();
        videojs.dom.blockTextSelection();
        if (!this.rs.options.locked) {
            this.pressed = true;
            videojs.on(document, "mouseup", videojs.bind(this, this.onMouseUp));
            videojs.on(document, "touchend", videojs.bind(this, this.onMouseUp));
            videojs.dom.addClass(this.el_, 'active');
        }
    };

    SelectionBarLeft.prototype.onMouseUp = function onMouseUp(event) {
        videojs.off(document, "mouseup", this.onMouseUp, false);
        videojs.off(document, "touchend", this.onMouseUp, false);
        videojs.dom.removeClass(this.el_, 'active');
        if (!this.rs.options.locked) {
            this.pressed = false;
        }
    };

    return SelectionBarLeft;
}(Component$6);

var Component$7 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var SelectionBarRight = function (_Component) {
    inherits(SelectionBarRight, _Component);

    function SelectionBarRight(player, options) {
        classCallCheck(this, SelectionBarRight);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;
        _this.on('mousedown', _this.onMouseDown);
        _this.on('touchstart', _this.onMouseDown);
        _this.pressed = false;

        options = options || {}; // plugin options

        _this.options = options;

        return _this;
    }

    /*Constructor*/


    SelectionBarRight.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
    };

    SelectionBarRight.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-rangeslider-handle vjs-selectionbar-right-RS',
            innerHTML: '<div class="vjs-selectionbar-arrow-RS"></div><div class="vjs-selectionbar-line-RS"></div>'
        });
    };

    SelectionBarRight.prototype.onMouseDown = function onMouseDown(event) {
        event.preventDefault();
        if (this.rs.options !== undefined && !this.rs.options.locked) {
            videojs.dom.blockTextSelection();
            this.pressed = true;
            videojs.on(document, "mouseup", videojs.bind(this, this.onMouseUp));
            videojs.on(document, "touchend", videojs.bind(this, this.onMouseUp));
            videojs.dom.addClass(this.el_, 'active');
        }
    };

    SelectionBarRight.prototype.onMouseUp = function onMouseUp(event) {
        videojs.off(document, "mouseup", this.onMouseUp, false);
        videojs.off(document, "touchend", this.onMouseUp, false);
        videojs.dom.removeClass(this.el_, 'active');
        if (!this.rs.options.locked) {
            this.pressed = false;
        }
    };

    return SelectionBarRight;
}(Component$7);

var Component$8 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var TimePanelLeft = function (_Component) {
    inherits(TimePanelLeft, _Component);

    function TimePanelLeft(player, options) {
        classCallCheck(this, TimePanelLeft);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;

        options = options || {}; // plugin options

        _this.options = options;
        return _this;
    }

    /*Constructor*/


    TimePanelLeft.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
    };

    TimePanelLeft.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-timepanel-left-RS',
            innerHTML: '<span class="vjs-time-text">00:00</span>'
        });
    };

    return TimePanelLeft;
}(Component$8);

var Component$9 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var TimePanelRight = function (_Component) {
    inherits(TimePanelRight, _Component);

    function TimePanelRight(player, options) {
        classCallCheck(this, TimePanelRight);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;

        options = options || {}; // plugin options

        _this.options = options;

        return _this;
    }

    /*Constructor*/


    TimePanelRight.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
    };

    TimePanelRight.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-timepanel-right-RS',
            innerHTML: '<span class="vjs-time-text">00:00</span>'
        });
    };

    return TimePanelRight;
}(Component$9);

var Component$10 = videojs.getComponent('Component');
/**
 * send mail button.
 */

var TimePanel = function (_Component) {
    inherits(TimePanel, _Component);

    function TimePanel(player, options) {
        classCallCheck(this, TimePanel);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-range-control-bar');
        _this.player = player;

        options = options || {}; // plugin options

        _this.options = options;
        return _this;
    }

    /*Constructor*/


    TimePanel.prototype.init_ = function init_() {
        this.rs = this.player_.rangeslider;
    };

    TimePanel.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-timepanel-RS'
        });
    };

    return TimePanel;
}(Component$10);

TimePanel.prototype.options_ = {
    children: {
        'TimePanelLeft': {},
        'TimePanelRight': {}
    }
};

// Default options for the plugin.
var defaults = {};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

videojs.registerComponent('RSTimeBar', RSTimeBar);
videojs.registerComponent('ControlTimePanel', ControlTimePanel);

videojs.registerComponent('ControlTimePanelLeft', RSTimeBar$2);
videojs.registerComponent('ControlTimePanelRight', ControlTimePanelRight);
videojs.registerComponent('SeekRSBar', SeekRSBar);
videojs.registerComponent('RSTimeBar', RSTimeBar);
videojs.registerComponent('SelectionBar', SelectionBar);
videojs.registerComponent('SelectionBarLeft', SelectionBarLeft);
videojs.registerComponent('SelectionBarRight', SelectionBarRight);
videojs.registerComponent('TimePanelLeft', TimePanelLeft);
videojs.registerComponent('TimePanel', TimePanel);
videojs.registerComponent('TimePanelRight', TimePanelRight);

//--Charge the new Component into videojs
var videojsSeekBar = videojs.getComponent('SeekBar');
videojsSeekBar.prototype.options_.children.push('RSTimeBar'); //Range Slider Time Bar

var videojsControlBar = videojs.getComponent('ControlBar');
videojsControlBar.prototype.options_.children.push('ControlTimePanel'); //Panel with the time of the range slider
/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
    player.addClass('vjs-range-slider');

    player.rangeslider = new RangeSlider(player, options);

    function initialVideoFinished(event) {
        var plugin = player.rangeslider;
        //All components will be initialize after they have been loaded by videojs
        for (var index in plugin.components) {
            plugin.components[index].init_();
        }

        if (plugin.options.hidden) plugin.hide(); //Hide the Range Slider

        if (plugin.options.locked) plugin.lock(); //Lock the Range Slider

        if (plugin.options.panel == false) plugin.hidePanel(); //Hide the second Panel

        if (plugin.options.controlTime == false) plugin.hidecontrolTime(); //Hide the control time panel

        plugin._reset();
        player.trigger('loadedRangeSlider'); //Let know if the Range Slider DOM is ready
    }
    if (player.techName == 'Youtube') {
        //Detect youtube problems
        player.one('error', function (e) {
            switch (player.error) {
                case 2:
                    alert("The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.");
                case 5:
                    alert("The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.");
                case 100:
                    alert("The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.");
                    break;
                case 101:
                    alert("The owner of the requested video does not allow it to be played in embedded players.");
                    break;
                case 150:
                    alert("The owner of the requested video does not allow it to be played in embedded players.");
                    break;
                default:
                    alert("Unknown Error");
                    break;
            }
        });
        player.on('firstplay', initialVideoFinished);
    } else {
        initialVideoFinished();
        player.one('playing-range-slider', initialVideoFinished);
    }
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function rangeSlider
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */

function RangeSlider(player, options) {
    var player = player || this;

    this.player = player;

    this.components = {}; // holds any custom components we add to the player

    options = options || {}; // plugin options

    if (!options.hasOwnProperty('locked')) options.locked = false; // lock slider handles

    if (!options.hasOwnProperty('hidden')) options.hidden = true; // hide slider handles

    if (!options.hasOwnProperty('panel')) options.panel = true; // Show Second Panel

    if (!options.hasOwnProperty('controlTime')) options.controlTime = true; // Show Control Time to set the arrows in the edition

    this.options = options;

    this.init();
}

RangeSlider.prototype = {
    /*Constructor*/
    init: function init() {
        var player = this.player || {};

        this.updatePrecision = 3;

        //position in second of the arrows
        this.start = 0;
        this.end = 0;

        //components of the plugin
        var controlBar = player.controlBar;
        var seekBar = controlBar.progressControl.seekBar;
        this.components.RSTimeBar = seekBar.RSTimeBar;
        this.components.ControlTimePanel = controlBar.ControlTimePanel;

        //Save local component
        this.rstb = this.components.RSTimeBar;
        this.box = this.components.SeekRSBar = this.rstb.SeekRSBar;
        this.bar = this.components.SelectionBar = this.box.SelectionBar;
        this.left = this.components.SelectionBarLeft = this.box.SelectionBarLeft;
        this.right = this.components.SelectionBarRight = this.box.SelectionBarRight;
        this.tp = this.components.TimePanel = this.box.TimePanel;
        this.tpl = this.components.TimePanelLeft = this.tp.TimePanelLeft;
        this.tpr = this.components.TimePanelRight = this.tp.TimePanelRight;
        this.ctp = this.components.ControlTimePanel;
        this.ctpl = this.components.ControlTimePanelLeft = this.ctp.ControlTimePanelLeft;
        this.ctpr = this.components.ControlTimePanelRight = this.ctp.ControlTimePanelRight;
        this.paramClosePlaySequence = false;
    },
    lock: function lock() {
        this.options.locked = true;
        this.ctp.enable(false);
        if (typeof this.box != 'undefined') videojs.dom.addClass(this.box.el_, 'locked');
    },
    unlock: function unlock() {
        this.options.locked = false;
        this.ctp.enable();
        if (typeof this.box != 'undefined') videojs.dom.removeClass(this.box.el_, 'locked');
    },
    show: function show() {
        this.options.hidden = false;
        if (typeof this.rstb != 'undefined') {
            this.rstb.show();
            if (this.options.controlTime) this.showcontrolTime();
        }
    },
    hide: function hide() {
        this.options.hidden = true;
        if (typeof this.rstb != 'undefined') {
            this.rstb.hide();
            this.ctp.hide();
        }
    },
    showPanel: function showPanel() {
        this.options.panel = true;
        if (typeof this.tp != 'undefined') videojs.dom.removeClass(this.tp.el_, 'disable');
    },
    hidePanel: function hidePanel() {
        this.options.panel = false;
        if (typeof this.tp != 'undefined') videojs.dom.addClass(this.tp.el_, 'disable');
    },
    showcontrolTime: function showcontrolTime() {
        this.options.controlTime = true;
        if (typeof this.ctp != 'undefined') this.ctp.show();
    },
    hidecontrolTime: function hidecontrolTime() {
        this.options.controlTime = false;
        if (typeof this.ctp != 'undefined') this.ctp.hide();
    },
    setValue: function setValue(index, seconds, writeControlTime) {
        //index = 0 for the left Arrow and 1 for the right Arrow. Value in seconds
        var writeControlTime = typeof writeControlTime != 'undefined' ? writeControlTime : true;

        var percent = this._percent(seconds);
        var isValidIndex = index === 0 || index === 1;
        var isChangeable = !this.locked;
        if (isChangeable && isValidIndex) this.box.setPosition(index, percent, writeControlTime);
    },
    setValueSeekBar: function setValueSeekBar(index, seconds, elementSeekBar, writeControlTime) {
        //index = 0 for the left Arrow and 1 for the right Arrow. Value in seconds
        var writeControlTime = typeof writeControlTime != 'undefined' ? writeControlTime : true;

        var percent = this._percent(seconds);
        var isValidIndex = index === 0 || index === 1;
        var isChangeable = !this.locked;
        if (isChangeable && isValidIndex) elementSeekBar.setPosition(index, percent, writeControlTime);
    },
    setValues: function setValues(start, end, writeControlTime) {
        //index = 0 for the left Arrow and 1 for the right Arrow. Value in seconds
        var writeControlTime = typeof writeControlTime != 'undefined' ? writeControlTime : true;

        this._reset();

        this._setValuesLocked(start, end, writeControlTime);
    },
    getValues: function getValues() {
        //get values in seconds
        var values = {},
            start,
            end;
        start = this.start || this._getArrowValue(0);
        end = this.end || this._getArrowValue(1);
        return { start: start, end: end };
    },
    playBetween: function playBetween(start, end, showRS) {
        showRS = typeof showRS == 'undefined' ? true : showRS;
        this.player.currentTime(start);
        this.player.play();
        if (showRS) {
            this.show();
            this._reset();
        } else {
            this.hide();
        }
        this._setValuesLocked(start, end);

        this.bar.activatePlay(start, end);
    },
    playsSequences: function playsSequences(sequences) {

        this.paramClosePlaySequence = false;
        this.bar.activateSequence(sequences, 0);
    },
    closePlaySequence: function closePlaySequence() {

        this.bar.closePlaySequence();
    },
    loop: function loop(start, end, show) {
        var player = this.player;

        if (player) {
            player.on("pause", videojs.bind(this, function () {
                this.looping = false;
            }));

            show = typeof show === 'undefined' ? true : show;

            if (show) {
                this.show();
                this._reset();
            } else {
                this.hide();
            }
            this._setValuesLocked(start, end);

            this.timeStart = start;
            this.timeEnd = end;
            this.looping = true;

            this.player.currentTime(start);
            this.player.play();

            this.player.on("timeupdate", videojs.bind(this, this.bar.process_loop));
        }
    },
    _getArrowValue: function _getArrowValue(index) {
        var index = index || 0;
        var duration = this.player.duration();

        duration = typeof duration == 'undefined' ? 0 : duration;

        var percentage = this[index === 0 ? "left" : "right"].el_.style.left.replace("%", "");
        if (percentage == "") percentage = index === 0 ? 0 : 100;

        return Math.round(this._seconds(percentage / 100), this.updatePrecision - 1);
    },
    _percent: function _percent(seconds) {
        var duration = this.player.duration();
        if (isNaN(duration)) {
            return 0;
        }
        return Math.min(1, Math.max(0, seconds / duration));
    },
    _seconds: function _seconds(percent) {
        var duration = this.player.duration();
        if (isNaN(duration)) {
            return 0;
        }
        return Math.min(duration, Math.max(0, percent * duration));
    },
    _reset: function _reset() {
        var duration = this.player.duration();
        this.tpl.el_.style.left = '0%';
        this.tpr.el_.style.left = '100%';
        this._setValuesLocked(0, duration);
    },
    _setValuesLocked: function _setValuesLocked(start, end, writeControlTime) {
        var triggerSliderChange = typeof writeControlTime != 'undefined';
        var writeControlTime = typeof writeControlTime != 'undefined' ? writeControlTime : true;
        if (this.options.locked) {
            this.unlock(); //It is unlocked to change the bar position. In the end it will return the value.
            this.setValue(0, start, writeControlTime);
            this.setValue(1, end, writeControlTime);
            this.lock();
        } else {
            if (end - start >= 5) {
                this.setValue(0, start, writeControlTime);
                this.setValue(1, end, writeControlTime);
            }
        }

        // Trigger slider change
        if (triggerSliderChange) {
            this._triggerSliderChange();
        }
    },
    _checkControlTime: function _checkControlTime(index, TextInput, timeOld) {
        var h = TextInput[0],
            m = TextInput[1],
            s = TextInput[2],
            newHour = h.value,
            newMin = m.value,
            newSec = s.value,
            obj,
            objNew,
            objOld;
        index = index || 0;

        if (newHour != timeOld[0]) {
            obj = h;
            objNew = newHour;
            objOld = timeOld[0];
        } else if (newMin != timeOld[1]) {
            obj = m;
            objNew = newMin;
            objOld = timeOld[1];
        } else if (newSec != timeOld[2]) {
            obj = s;
            objNew = newSec;
            objOld = timeOld[2];
        } else {
            return false;
        }

        var duration = this.player.duration() || 0,
            durationSel;

        var intRegex = /^\d+$/; //check if the objNew is an integer
        if (!intRegex.test(objNew) || objNew > 60) {
            objNew = objNew == "" ? "" : objOld;
        }

        newHour = newHour == "" ? 0 : newHour;
        newMin = newMin == "" ? 0 : newMin;
        newSec = newSec == "" ? 0 : newSec;

        durationSel = parseTimeStamp(newHour + ":" + newMin + ":" + newSec);
        if (durationSel > duration) {
            obj.value = objOld;
            obj.style.border = "1px solid red";
        } else {
            obj.value = objNew;
            h.style.border = m.style.border = s.style.border = "1px solid transparent";
            this.setValue(index, durationSel, false);

            // Trigger slider change
            this._triggerSliderChange();
        }
        if (index === 1) {
            var oldTimeLeft = this.ctpl.el_.children,
                durationSelLeft = parseTimeStamp(oldTimeLeft[0].value + ":" + oldTimeLeft[1].value + ":" + oldTimeLeft[2].value);
            if (durationSel < durationSelLeft) {
                obj.style.border = "1px solid red";
            }
        } else {

            var oldTimeRight = this.ctpr.el_.children,
                durationSelRight = parseTimeStamp(oldTimeRight[0].value + ":" + oldTimeRight[1].value + ":" + oldTimeRight[2].value);
            if (durationSel > durationSelRight) {
                obj.style.border = "1px solid red";
            }
        }
    },
    _triggerSliderChange: function _triggerSliderChange() {
        this.player.trigger("sliderchange");
    }
};

function parseTimeStamp(input) {

    function computeSeconds(h, m, s) {
        return (h | 0) * 3600 + (m | 0) * 60 + (s | 0);
    }

    var m = input.match(/^(\d+):(\d+):(\d+)/);
    if (!m) {
        return null;
    }

    return computeSeconds(m[1], m[2], m[3]);
}

//----------------Public Functions----------------//

//-- Public Functions added to video-js

var videojsPlayer = videojs.getComponent('Player');

//Lock the Slider bar and it will not be possible to change the arrow positions
videojsPlayer.prototype.lockSlider = function () {
    return this.rangeslider.lock();
};

//Unlock the Slider bar and it will be possible to change the arrow positions
videojsPlayer.prototype.unlockSlider = function () {
    return this.rangeslider.unlock();
};
videojsPlayer.prototype.closePlaySequence = function () {
    return this.rangeslider.closePlaySequence();
};
//Show the Slider Bar Component
videojsPlayer.prototype.showSlider = function () {
    return this.rangeslider.show();
};

//Hide the Slider Bar Component
videojsPlayer.prototype.hideSlider = function () {

    return this.rangeslider.hide();
};

//Show the Panel with the seconds of the selection
videojsPlayer.prototype.showSliderPanel = function () {
    return this.rangeslider.showPanel();
};

//Hide the Panel with the seconds of the selection
videojsPlayer.prototype.hideSliderPanel = function () {
    return this.rangeslider.hidePanel();
};

//Show the control Time to edit the position of the arrows
videojsPlayer.prototype.showControlTime = function () {
    return this.rangeslider.showcontrolTime();
};

//Hide the control Time to edit the position of the arrows
videojsPlayer.prototype.hideControlTime = function () {
    return this.rangeslider.hidecontrolTime();
};

//Set a Value in second for both arrows
videojsPlayer.prototype.setValueSlider = function (start, end) {
    return this.rangeslider.setValues(start, end);
};

//The video will be played in a selected section
videojsPlayer.prototype.playBetween = function (start, end) {
    return this.rangeslider.playBetween(start, end);
};

videojsPlayer.prototype.playsSequences = function (sequence) {
    return this.rangeslider.playsSequences(sequence);
};

//The video will loop between to values
videojsPlayer.prototype.loopBetween = function (start, end) {
    return this.rangeslider.loop(start, end);
};

//Set a Value in second for the arrows
videojsPlayer.prototype.getValueSlider = function () {
    return this.rangeslider.getValues();
};

var rangeSlider = function rangeSlider(options) {
    var _this = this;

    this.ready(function () {
        onPlayerReady(_this, videojs.mergeOptions(defaults, options));
    });
};

// Register the plugin with video.js.
registerPlugin('rangeSlider', rangeSlider);

// Include the version number.
rangeSlider.VERSION = version;

return rangeSlider;

})));



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_range_slider/dist/videojs-range-slider.js
// module id = 562
// module chunks = 1